import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {Button, Heading, Text} from '@albert-io/atomic';
import {Link} from 'react-router';
import {getModelForResourceType} from 'resources/modelRegistry';
import sessionStore from 'client/Session/SessionStore';

import ChangePassword from 'client/components/ChangePassword/ChangePassword.react';
import FeatureFlag from 'client/components/FeatureFlag/FeatureFlag.react';

import ContentPersonalization from '../ContentPersonalization/ContentPersonalization.react';

import './password-and-settings.scss';

const PasswordAndSettings = ({user}) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className='password-settings'>
      {showPassword ? (
        <>
          <Heading uppercase size='xxs' withMargin>
            Change Password
          </Heading>
          <ChangePassword
            userId={user.getId()}
            handleClose={() => setShowPassword(false)}
            onSubmitCallback={() => setShowPassword(false)}
            onCancel={() => setShowPassword(false)}
            hideCloseBtn
            title=''
            className='password-settings__change-password-container u-border_none'
          />
        </>
      ) : (
        <>
          <Heading size='xxs' withMargin className='password-settings__header'>
            Password & Settings
          </Heading>
          <div className='password-settings__button-group u-display_flex u-align-items_center u-flex-direction_column u-pad-tb_4 u-pad-lr_4'>
            <Button onClick={() => setShowPassword(true)} className='u-width_100pc u-mar-r_1'>
              Change password
            </Button>
            <Button as={Link} to='/account/deactivate' color='secondary' className='u-width_100pc'>
              Deactivate account
            </Button>
          </div>

          {!sessionStore.isStudent() && (
            <FeatureFlag name='content_personalization'>
              <>
                <Heading
                  size='xxs'
                  withMargin
                  className='password-settings__header u-mar-t_8 u-mar-b_1'
                >
                  Content Preferences
                </Heading>
                <Text>The site will display more relevant content based on your preferences.</Text>
                <ContentPersonalization className='u-mar-t_2' />
              </>
            </FeatureFlag>
          )}
        </>
      )}
    </div>
  );
};

PasswordAndSettings.propTypes = {
  user: PropTypes.instanceOf(getModelForResourceType('user_v2'))
};

export default PasswordAndSettings;
